var React = require('react');

function Weight (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M256 320A160 160 0 1 0 96 160a160 160 0 0 0 160 160zm-.28-152l33.56-78.3a16 16 0 0 1 29.44 12.59l-33.58 78.33A40 40 0 1 1 255.72 168z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M512 128v320a64.07 64.07 0 0 1-64 64H64a64.07 64.07 0 0 1-64-64V128a64.07 64.07 0 0 1 64-64h26a190.6 190.6 0 0 0-26 96c0 105.87 86.13 192 192 192s192-86.13 192-192a190.6 190.6 0 0 0-26-96h26a64.07 64.07 0 0 1 64 64zM256 248a40 40 0 0 0 29.14-67.38l33.58-78.33a16 16 0 0 0-29.44-12.59L255.72 168a40 40 0 0 0 .28 80z","className":"fa-primary","key":2})]);
}

Weight.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Weight;

Weight.default = Weight;
